const moment = require('moment');
const { merge } = require('lodash');

const DEFAULT_OPTIONS = {
  time: { withSeconds: false },
  date: { withDay: true, withMonth: true },
};
export const localizeDate = function (timestamp, context, options) {
  if (!context) {
    context = this;
  }

  options = merge({}, DEFAULT_OPTIONS, options);

  moment.locale(
    (context && context.$store ? context.$store.state.app.language : false) ||
      window.navigator.userLanguage ||
      window.navigator.language
  );

  let format = '';

  if (options.date) {
    if (options.date.withDay && options.date.withMonth) {
      format = 'L'; // Full date
    } else if (options.date.withDay) {
      throw new Error('You cannot use the "withDay" option without the "withMonth" option');
    } else if (options.date.withMonth) {
      // long format month and full year
      format = 'MMM YYYY'; // Month and full year
    }
  }

  if (options.time) {
    if (format) {
      format += ' ';
    }

    if (options.time.withSeconds) {
      format += 'LTS';
    } else {
      format += 'LT';
    }
  }

  return moment(timestamp).format(format);
};
